export default "__VITE_ASSET__DLGHp$ms__"